import { render } from "./DoubleRadioInput.vue?vue&type=template&id=796eb411&scoped=true"
import script from "./DoubleRadioInput.vue?vue&type=script&lang=js"
export * from "./DoubleRadioInput.vue?vue&type=script&lang=js"

import "./DoubleRadioInput.vue?vue&type=style&index=0&id=796eb411&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796eb411"]])

export default __exports__